export const TYPES_NAMES = {
  'category': 'Categórica',
  'number': 'Numérica',
  'indicator': 'Sub-indicador',
};


export function metrics_formula_fun(formula) {
  /**
   * Return a function for the given formula string
   */
  const FORMULAS = {
    sum: (arr) => (arr.reduce((partsum, a) => partsum + a, 0)),
    mul: (arr) => (arr.reduce((partsum, a) => partsum * a, 1)),
  };
  return FORMULAS[formula] || FORMULAS['sum'];
}
